import React from "react";
import useEditableTableTextCell from "../../../hooks/useEditableTableTextCell";



export default function NewOptionRow({onChange, index, option}){

    return (
        <tr>
            <td>
                {useEditableTableTextCell({
                    propName: "name",
                    editable: true,
                    setEditable: () => true,
                    disabled: false,
                    inlineEdit: false,
                    value: option.name,
                    onChange: (e) => onChange(e, index)
                })}
            </td>
        </tr>
    )




}